module.exports = __webpack_public_path__ + "static/success-be4ea62f3d73690f69f18bc41b6737ba.png";